<woo-modal-layout size="medium" (close)="close()">
    <h3 header >Skapa ny rabatt</h3>
    <new-ad-hoc-contract
        (onNewAdHocContract)="submit.emit($event)"
        (onAbort)="close()"
        [agencies]="agencies()"
        [adOrganisations]="adOrganisations()"
    ></new-ad-hoc-contract>
</woo-modal-layout>
